import React from 'react';
import { Link, useParams } from 'react-router-dom';
import dishListIconMark from '../images/dishlist-icon-mark.png';
import './DishListInvite.css';

const inviteIDPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function DishListInvite() {
  const { inviteId = '' } = useParams();
  const isValidInviteID = inviteIDPattern.test(inviteId);
  const appURL = `dishlist42pets://invite/${encodeURIComponent(inviteId)}`;

  return (
    <div className="dishlist-invite-page">
      <section className="dishlist-invite-card" aria-labelledby="invite-title">
        <div className="dishlist-invite-icon" aria-hidden="true">
          <img src={dishListIconMark} alt="" />
        </div>

        {isValidInviteID ? (
          <>
            <p className="dishlist-invite-eyebrow">DishList family invitation</p>
            <h1 id="invite-title">You’re invited to plan meals together</h1>
            <p className="dishlist-invite-copy">
              Open DishList to review this invitation, join the family, and share your meal preferences.
            </p>
            <a className="dishlist-invite-button" href={appURL}>
              Open in DishList
            </a>
            <div className="dishlist-invite-help">
              <h2>Don’t have DishList yet?</h2>
              <p>
                DishList is currently in testing. Install the app from TestFlight first, then return to this invitation.
              </p>
            </div>
          </>
        ) : (
          <>
            <p className="dishlist-invite-eyebrow">DishList family invitation</p>
            <h1 id="invite-title">This invitation link isn’t valid</h1>
            <p className="dishlist-invite-copy">
              Ask the person who invited you to create and share a new link.
            </p>
            <Link className="dishlist-invite-secondary-button" to="/apps/dishlist">
              Learn about DishList
            </Link>
          </>
        )}

        <p className="dishlist-invite-footnote">
          Only accept invitations from someone you know.
        </p>
      </section>
    </div>
  );
}

export default DishListInvite;
